import script from "./PrintBoxCode.vue?vue&type=script&lang=ts&setup=true"
export * from "./PrintBoxCode.vue?vue&type=script&lang=ts&setup=true"

import "./PrintBoxCode.vue?vue&type=style&index=0&id=bac1433a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bac1433a"]])

export default __exports__